import './Helper/Polyfill';
import SocializeRequestHandler from './Compoents/SocializeRequestHandler';
import CommentHandler from './Compoents/CommentHandler';

export default class LinSocializeWidget {

  constructor() {
    this.SOCIALIZE_REQUEST_HANDLER;
    this.COMMENT_HANDLER;

    this.initComponents().then(_ => {
      this.registerHooks();
    });

  }

  /**
   * Initialize components for LinSocializeWidget
   * @private
   * @example
   * this.initComponents()
   */
  initComponents() {
    const _this = this;

    return new Promise(resolve => {
      _this.COMMENT_HANDLER = new CommentHandler();
      _this.SOCIALIZE_REQUEST_HANDLER = new SocializeRequestHandler();
      _this.SOCIALIZE_REQUEST_HANDLER.updateSocializeItems();
      resolve();
    });
  }

  /**
   * Register events for LinSocializeWidget
   * @private
   * @example
   * this.registerHooks()
   */
  registerHooks() {
    const _this = this;

    $('body').on('lin-socialize:comments:updated', function() {
      _this.SOCIALIZE_REQUEST_HANDLER.updateSocializeItems();
    });

    $('body').on('tx_solr_updated', function() {
        console.log('event triggered');
        _this.SOCIALIZE_REQUEST_HANDLER.updateSocializeItems();
    });

    $('body').on('lin-bookmark:bookmarks:updated', function() {
      _this.SOCIALIZE_REQUEST_HANDLER.updateSocializeItems();
    });

    /**
     * copy link to clipboard
     */
    $('body').on('click', 'button[data-socialize-type="clipboard"]', function(e) {
      e.preventDefault();
      let $button = $(this);
      navigator.clipboard.writeText($button.data('socialize-url'));
      $button.find(".js-copied-text").show().delay(3000).fadeOut();
    });

    /**
     * Performs toggle-like-action on corresponding news.
     */
    $('body').on('click', 'button[data-socialize-type="like"]', function(e) {
      e.preventDefault();
      let $button = $(this);
      _this.SOCIALIZE_REQUEST_HANDLER.performButtonAction($button);
    });

  }

}

jQuery(document).ready( e => {
  new LinSocializeWidget();
});
